import HeroSection from "@/components/home/HeroSection";
import FeaturedProducts from "@/components/home/FeaturedProducts";
import FeaturesSection from "@/components/home/FeaturesSection";
import TrackOrder from "@/components/home/TrackOrder";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import FloatingCart from "@/components/layout/FloatingCart";
import FloatingWhatsApp from "@/components/layout/FloatingWhatsApp";
import SEOHead from "@/components/SEOHead";

const Index = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Store",
    name: "Bait Al-Teeb",
    description: "Premium online fragrance destination featuring luxury, niche, and timeless designer brands.",
    url: "https://bait-al-teeb-essence.lovable.app",
    image: "https://bait-al-teeb-essence.lovable.app/favicon.ico",
    priceRange: "$$",
    address: { "@type": "PostalAddress", addressCountry: "EG" },
  };

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Bait Al-Teeb — Premium Fragrances"
        description="Discover luxury perfumes and niche fragrances at Bait Al-Teeb. Shop curated scents for every occasion with free tracking."
        canonical="https://bait-al-teeb-essence.lovable.app"
        jsonLd={jsonLd}
      />
      <Navbar />
      <FloatingCart />
      <FloatingWhatsApp />
      <main>
        <HeroSection />
        <FeaturedProducts />
        <FeaturesSection />
        <TrackOrder />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
